import CountDown from "@/src/components/ui/molecules/CountDown/CountDown";
import { JamEventDetails } from "@/src/types/JamEventDetails";
import { i18nKeys } from "@/src/utils/i18n.utils";
import { Box, SpaceBetween } from "@amzn/awsui-components-react";
import moment from "moment";
import { memo } from "react";
import { useTranslation } from "react-i18next";

const PresenterModeTitle: React.FC<{
  event: JamEventDetails | undefined;
  getCarouselTitle: (index: number) => string;
  carouselIndex: number;
  showWinners: boolean;
  endDate: string | undefined;
}> = memo(({ event, getCarouselTitle, carouselIndex, showWinners, endDate }) => {
  const { t } = useTranslation();
  return (
    <SpaceBetween size="m">
      <Box variant="h1" color="text-body-secondary">
        {event?.title}
      </Box>
      <Box>
        <Box variant="h2" float="left">
          {getCarouselTitle(carouselIndex)}
        </Box>
        {!showWinners && (
          <Box float="right">
            <Box variant="h2" tagOverride="span" display="inline">
              {t(i18nKeys.jamDashboard.leaderboard.timeLeft)}:
            </Box>{' '}
            &nbsp; <CountDown targetDate={endDate ? moment(endDate).valueOf() : 0} />
          </Box>
        )}
      </Box>
    </SpaceBetween>
  );
});

export default PresenterModeTitle;